import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getInOfficeHeadcountBasedQuantites, getFixedQuantities } from './utils';

export const pantry = [
  {
    id: 23,
    name: 'spaceTypes.pantry.galleyPantry',
    displayOrder: 1,
    spaceTypeId: spaceTypes.pantry.id,
    size: {
      [countries.US]: getSize(15.0, 10.0),
      [countries.UK]: getSize(15.0, 10.0),
      [countries.FR]: getSize(3.0, 4.0),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818121/insite/qa/spaces/a3muki5rfpzc9byv5r0k.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818121/insite/qa/spaces/a3muki5rfpzc9byv5r0k.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818121/insite/qa/spaces/a3muki5rfpzc9byv5r0k.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818121/insite/qa/spaces/a3muki5rfpzc9byv5r0k.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818121/insite/qa/spaces/a3muki5rfpzc9byv5r0k.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 24,
    name: 'spaceTypes.pantry.smallBreakRoom',
    displayOrder: 2,
    spaceTypeId: spaceTypes.pantry.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.0, 6.0),
      [countries.EU]: getSize(3.0, 5.0),
      [countries.DE]: getSize(3.0, 5.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818122/insite/qa/spaces/r85jb7dr6cmhous6tkzo.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818122/insite/qa/spaces/r85jb7dr6cmhous6tkzo.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818122/insite/qa/spaces/r85jb7dr6cmhous6tkzo.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818122/insite/qa/spaces/r85jb7dr6cmhous6tkzo.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818122/insite/qa/spaces/r85jb7dr6cmhous6tkzo.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 25,
    name: 'spaceTypes.pantry.largeCafe',
    displayOrder: 3,
    spaceTypeId: spaceTypes.pantry.id,
    size: {
      [countries.US]: getSize(20.0, 20.0),
      [countries.UK]: getSize(20.0, 20.0),
      [countries.FR]: getSize(7.0, 12.0),
      [countries.EU]: getSize(6.0, 8.0),
      [countries.DE]: getSize(6.0, 8.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499759/insite/qa/spaces/yvo4pboqz2fgtzjmgy2c.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499759/insite/qa/spaces/yvo4pboqz2fgtzjmgy2c.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499759/insite/qa/spaces/yvo4pboqz2fgtzjmgy2c.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499759/insite/qa/spaces/yvo4pboqz2fgtzjmgy2c.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499759/insite/qa/spaces/yvo4pboqz2fgtzjmgy2c.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
